import React, { useState } from "react";
import Image02 from "../assets/feedHeadlines.svg";
import Image03 from "../assets/svg/feedHeadlinesSm.svg";

const GroupRight = () => {
  const [Location] = useState(window.location.pathname.split(" ")[0]);
  return (
    <div className="w-[25%] sticky top-[110px] h-[calc(100vh-110px)] overflow-scroll scrollbar-hide">
      <p className="text-lg font-bold pb-5">
        {Location.includes("/weather")
          ? "Suggestions"
          : "Local News and Headlines"}
      </p>
      <div className="border-2 rounded-xl p-3">
        <img src={Image02} alt="" className="w-full object-cover" />
        <p className="font-medium pt-3 text-sm pr-5">
          What to watch in Tuesday's primaries in California, Iowa, and more
        </p>
        <p className="text-red-500 text-xs text-end">Sponsored</p>
      </div>
      <div className="flex items-center border-2 rounded-xl py-3 pr-1 pl-2 mt-3">
        <img src={Image03} alt="" />
        <div className="pl-2">
          <p className="text-xs">
            What to watch in Tuesday's primaries in California, Iowa
          </p>
          <p className="text-[10px] text-black text-opacity-50">
            What to watch in Tuesday's primaries in California, Iowa and more
          </p>
        </div>
      </div>
      <div className="flex items-center border-2 rounded-xl py-3 pr-1 pl-2 mt-3">
        <img src={Image03} alt="" />
        <div className="pl-2">
          <p className="text-xs">
            What to watch in Tuesday's primaries in California, Iowa
          </p>
          <p className="text-[10px] text-black text-opacity-50">
            What to watch in Tuesday's primaries in California, Iowa and more
          </p>
        </div>
      </div>
      <div className="flex items-center border-2 rounded-xl py-3 pr-1 pl-2 mt-3">
        <img src={Image03} alt="" />
        <div className="pl-2">
          <p className="text-xs">
            What to watch in Tuesday's primaries in California, Iowa
          </p>
          <p className="text-[10px] text-black text-opacity-50">
            What to watch in Tuesday's primaries in California, Iowa and more
          </p>
        </div>
      </div>
      <p className="text-center font-semibold m-3">See All</p>
    </div>
  );
};

export default GroupRight;
